export class DisableLink {
    link: HTMLLinkElement;

    constructor(linkToDisable: HTMLLinkElement) {
        this.link = linkToDisable;
        this.link.onclick = (e) => {
            this.link.setAttribute('disabled', '');
            this.link.classList.add('btn-loading');
            //prevent subsequent clicks
            this.link.onclick = (eventToPrevent) => {
                eventToPrevent.preventDefault();
            }
        }
    }
}